import { Component } from '@angular/core';
@Component({
    selector: 'kh-merge-complete',
    styleUrls: ['./merge-complete.component.less'],
    templateUrl: './merge-complete.component.html',
    standalone: false
})
export class MergeCompleteComponent {

}
